import angular from 'angular';
import template from './fillable-paragraph.html';
import TemplateParser from './TemplateParser';

export default angular
  .module(
    'doxy.realtime.components.teleconsent.action.document.page.form.fillableParagraph',
    []
  )
  .component('tcFillableParagraph', {
    template,
    require: {
      form: '?^^form',
    },
    bindings: {
      me: '<',
      data: '<',
      fields: '<',
      element: '<',
      disabled: '<',
    },
    controller: function ($scope) {
      this.$onInit = function() {
        // Ensure bindings are available before accessing them
        if (this.fields && this.element && this.element.name) {
          this.field = this.fields[this.element.name];
          
          $scope.$watch('$ctrl.field.template', (newTemplate) => {
            this.parts = new TemplateParser().parse(newTemplate);
          });

          this.disabled =
            !this.me || !(this.field.editBy === this.me.type || !this.field.editBy);
        } else {
          console.warn('FillableParagraph: fields or element not available');
        }
      };
    },
  }).name;
